(function () {
    'use strict';

    angular.module("imApp").factory("p2OffDutyDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 572,
                    parameters: parms || {}
                });
            },
            listOffDutyDatas: function (parms) {
                return $ihttp.post({
                    method: 573,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
